import React, { useState } from 'react'
import { NavLink } from 'react-router-dom'
import InputCutLaze from './InputCutLaze'
import InputCutLazeError from './InputCutLazeError'


function LazaCuttingPage() {

    const [activeTab, setActiveTab] = useState('cutlaze')

    const handleChangeActivePage = (page) => {
        setActiveTab(page)
    }

    return (
        <div className="LazaCuttingPage py-5">
            <div className="col-12 mx-auto px-5">
                <div className="d-flex align-items-baseline justify-content-between">
                    <div className="d-flex">
                        <h1
                            onClick={() => handleChangeActivePage('cutlaze')}
                            className={activeTab === "cutlaze" ? "PageTitle pr-3 cutlazePage" : "PageTitle pr-3"}
                        >Đánh dấu cắt laze
                        </h1>
                        <h1
                            onClick={() => handleChangeActivePage('')}
                            className={activeTab === "" ? "pl-3 notCutlazePage" : "pl-3"}
                        >
                            Đánh dấu cắt lỗi
                        </h1>
                    </div>
                    <label className="border rounded cursor-pointer font-weight-bold py-2 px-4 bg-white h6">
                        {activeTab === "cutlaze" ?
                            <NavLink exact to='/list-laze' className='nav-link p-0'>
                                Danh sách cắt laze
                            </NavLink> :
                            <NavLink exact to='/list-laze-error' className='nav-link p-0'>
                                Danh sách cắt lỗi
                            </NavLink>
                        }
                    </label>
                </div>
                {
                    activeTab === "cutlaze" ? <InputCutLaze /> :
                        <InputCutLazeError />
                }
            </div>
        </div>

    )
}

export default LazaCuttingPage